import { useBillingApi } from '@/api/cloudApi'
import type {
  V1alpha1Discount,
  V1alpha1DiscountApplication
} from '@streamnative/cloud-api-client-typescript'

export type { V1alpha1Discount, V1alpha1DiscountApplication }

export const fetchDiscountApplications = async (
  org: string
): Promise<V1alpha1DiscountApplication[]> => {
  const api = useBillingApi()
  const response = await api.listNamespacedDiscountApplication(org)
  return response.data?.items ?? []
}

export const applyDiscount = async (
  org: string,
  discountName: string
): Promise<V1alpha1DiscountApplication> => {
  const api = useBillingApi()
  const body: V1alpha1DiscountApplication = {
    metadata: { name: discountName, namespace: org },
    spec: {}
  }
  const response = await api.createNamespacedDiscountApplication(org, body)
  return response.data
}
